import { app } from '../../app.module'
app
  // アカウント分析
  .directive('accountAnalytics', () => {
    return {
      restrict: 'E',
      template: require('./account-analytics.pug')(),
      controller: (
        $rootScope,
        $scope,
        $timeout,
        $state,
        AccountAnalyticsService,
        PostService,
        AccountDetailModalService,
        RestangularService
      ) => {
        $scope.selectedPeriodType = 'month'
        // 分析画面の場合、デフォルトは日別にセット
        if ($state.current !== undefined && $state.current.name === 'analytics') {
          $scope.selectedPeriodType = 'dayOfMonth'
        }

        $scope.isNoPosts = false
        $scope.updateIsNoPost = (flag: boolean) => {
          $scope.isNoPosts = flag
        }

        setQueryOptions()

        /**
         * setQueryOptions 分析データ取得のクエリのオプションをセット
         */
        function setQueryOptions() {
          let accountId = null
          let stateName = null

          // stateが存在する場合
          if ($state.current !== undefined) {
            stateName = $state.current.name

            // 分析画面以外の場合、アカウントIDをセット
            if (stateName !== 'analytics') {
              accountId = $scope.accountId
            }
          }

          // フィルタリングのオプションをセット
          $scope.getOptions = AccountAnalyticsService.Data.setFilterOptions(
            {
              startDate: $scope.startDate,
              endDate: $scope.endDate,
            },
            stateName,
            accountId
          )
        }

        /**
         * resetSuggestFilter サジェストオプションをリセット
         */
        function resetSuggestOptions() {
          PostService.Action.accountLists = null
          PostService.Action.tagLists = null
          PostService.Action.accountTagLists = null
          PostService.Action.hashtagLists = null
          $scope.getOptions.userId = $rootScope.userId
        }

        /**
         * initAnalyticsScope 分析機能に必要なスコープを初期化
         */
        function initAnalyticsScope(changeDailyFlg = true) {
          $scope.isLoading = true
          // アカウント分析のデータ
          $scope.analyticsData = null
          // 1投稿あたりのフラグ
          $scope.dataPerPostFlg = true
          // 1投稿あたりのインプレッション
          $scope.dataImpressionsPerPostFlg = true
          // アカウント数
          $scope.accountsCount = null
          if (changeDailyFlg) {
            $scope.dailyFlg = false
          }
          // クエリオプション(ハッシュタグタブ用)
          $scope.query = {
            order: 'engagements',
            limit: 25,
            options: [10, 25, 50],
            page: 1,
            hashtagCount: null,
          }
          if ($scope.snsType === 'youtube') {
            $scope.query.order = 'views'
          } else if ($scope.snsType === 'tiktok') {
            $scope.query.order = 'plays'
          }
          // サジェストオプションをリセット
          resetSuggestOptions()
        }

        initAnalyticsScope()

        /**
         * setHashtagQueryOptions ハッシュタグタブのデータを取得するオプションを追加
         * @return 取得するオプション
         */
        function setHashtagQueryOptions() {
          $scope.getOptions.limit = $scope.query.limit
          $scope.getOptions.order = AccountAnalyticsService.Data.setOrderObject(
            $scope.query.order,
            $scope.dataPerPostFlg
          )
          $scope.getOptions.page = $scope.query.page
          $scope.getOptions.hashtagCount = $scope.query.hashtagCount
        }

        /**
         * changePeriodType グラフの期間を変更するイベント
         */
        $scope.$on('changePeriodType', (event, periodType: string) => {
          switch (periodType) {
            case '月別':
              $scope.selectedPeriodType = 'month'
              break

            case '曜日別':
              $scope.selectedPeriodType = 'dayOfWeek'
              break

            case '日別':
              $scope.selectedPeriodType = 'dayOfMonth'
              break

            case '時間帯別':
              $scope.selectedPeriodType = 'hour'
              break
          }

          $scope.dailyFlg = false
          $scope.isPeriodChangeLoading = true

          // アカウント詳細のデータを取得する
          getAnalyticsData()
        })

        /**
         * ハッシュタグフィルターデータをセット
         * @param {string} searchStrings 検索文字列
         */
        $scope.queryHashtagSearch = (searchStrings: string) => {
          return PostService.Search.getHashtagList(
            searchStrings,
            $scope.selectedTab,
            $scope.getOptions
          )
        }

        /**
         * アカウントフィルターデータをセット
         * @param {string} searchStrings 検索文字列
         */
        $scope.queryAccountSearch = (searchStrings: string) => {
          return PostService.Search.queryFilterSearch(
            searchStrings,
            'getAccount',
            $scope.selectedTab,
            $scope.getOptions
          )
        }

        /**
         * changeDailyFlag 1日毎に表示フラグを変更するイベント
         * @param {boolean} dailyFlg 1日毎に表示フラグ
         */
        $scope.changeDailyFlag = function (dailyFlg: boolean) {
          $scope.dailyFlg = dailyFlg
          $scope.isPeriodChangeLoading = true
          // アカウント詳細のデータを取得する
          getAnalyticsData()
        }

        /**
         * changePerPostFlag 1投稿あたりのフラグを変更するイベント
         */
        $scope.changePerPostFlag = function (dataPerPostFlg: boolean) {
          $scope.dataPerPostFlg = dataPerPostFlg
          // アカウント詳細のデータを取得する
          getAnalyticsData()
        }

        /**
         * changeImpressionsPerPostFlag 1投稿あたりのフラグを変更するイベント
         */
        $scope.changeImpressionsPerPostFlag = function (dataImpressionsPerPostFlg: boolean) {
          $scope.dataImpressionsPerPostFlg = dataImpressionsPerPostFlg
          // アカウント詳細のデータを取得する
          getAnalyticsData()
        }

        /**
         * フォロワー数範囲の変更イベント
         * @param {string[]} followerRange フォロワー数範囲
         */
        $scope.changeFollowerFilter = (followerRange: string[]) => {
          if ($rootScope.followerFilter === followerRange) {
            return
          }
          $rootScope.followerFilter = followerRange
          // フィルターを変更する
          changeFilter({
            value: followerRange,
            type: 'followerRangeFilter',
          })
        }

        /**
         * アカウントグローバルの変更イベント
         * @param {number} accountGlobal アカウントグローバル
         */
        $scope.changeAccountGlobalFilter = (accountGlobal: number) => {
          if ($rootScope.accountGlobalFilter === accountGlobal) {
            return
          }
          $rootScope.accountGlobalFilter = accountGlobal
          // フィルターを変更する
          changeFilter({
            value: accountGlobal >= 0 ? accountGlobal : null,
            type: 'accountGlobalFilter',
          })
        }

        /**
         * キーワードの変更イベント
         * @param {string} keyword キーワード
         */
        $scope.changeKeywordFilter = (keyword: string) => {
          if ($rootScope.messageFilter === keyword) {
            return
          }
          $rootScope.messageFilter = keyword
          // フィルターを変更する
          changeFilter({
            value: keyword,
            type: 'keywordFilter',
          })
        }

        /**
         * 投稿タイプの変更イベント
         * @param {string} postType 投稿タイプ
         */
        $scope.changePostType = (postType: string) => {
          if ($rootScope.postTypeFilter === postType) {
            return
          }
          $rootScope.postTypeFilter = postType
          // フィルターを変更する
          changeFilter({
            value: postType,
            type: 'postTypeFilter',
          })
        }

        /**
         * ハッシュタグの変更イベント
         * @param {string} searchStrings 検索文字列
         */
        $scope.changeHashtag = (searchStrings: string) => {
          if ($rootScope.hashtagFilter === searchStrings) {
            return
          }
          $rootScope.hashtagFilter = searchStrings
          // フィルターを変更する
          changeFilter({
            value: searchStrings,
            type: 'postHashtagFilter',
          })
        }

        /**
         * 選択した投稿タグリストの変更イベント
         * @param {string[]} selectedTags 選択したタグリスト
         * @returns void
         */
        $scope.changeSelectedPostTags = (selectedTags: string[]) => {
          $rootScope.postTagFilter = selectedTags
          // フィルターを変更する
          changeFilter({
            value: selectedTags,
            type: 'postTagFilter',
          })
        }

        /**
         * 選択したアカウントタグリストの変更イベント
         * @param {string[]} selectedTags 選択したタグリスト
         * @returns void
         */
        $scope.changeSelectedAccountTags = (selectedTags: string[]) => {
          $rootScope.accountTagFilter = selectedTags
          // フィルターを変更する
          changeFilter({
            value: selectedTags,
            type: 'accountTagFilter',
          })
        }

        /**
         * アカウント検索の変更イベント
         * @param {string} searchStrings 検索文字列
         */
        $scope.changeAccountSearch = (searchStrings: string) => {
          if ($scope.getOptions.accountFilter === searchStrings) {
            return
          }
          $scope.getOptions.accountFilter = searchStrings
          // フィルターを変更する
          changeFilter({
            value: searchStrings,
            type: 'accountFilter',
          })
        }

        /**
         * changeFilterData ディレクティブから、'changeFilterData'を受信した場合
         */
        $scope.$on('changeFilterData', (event, filterInfo) => {
          // 相関タブの場合は、リターン
          if ($scope.analyticsTab === 'correlation') {
            return
          }
          // 投稿のサブカテゴリではない場合は、リターン
          if (filterInfo.type === 'subCategoryFilter' && filterInfo.subCategoryType !== 'post') {
            return
          }
          // フィルターを変更する
          changeFilter(filterInfo)
        })

        /**
         * 対象日付の変更を検知してグラフ設定
         */
        $scope.$on('changeDateRange', (event, startEndDate) => {
          // 相関タブの場合は、リターン
          if ($scope.analyticsTab === 'correlation') {
            return
          }
          // date-range-pickerで期間を指定した場合、セット
          if (startEndDate.startDate !== undefined && startEndDate.endDate !== undefined) {
            $scope.getOptions.startEndDate = startEndDate
            initAnalyticsScope(false)
            // アカウント詳細のデータを取得する
            getAnalyticsData()
          }
        })

        /**
         * changeBrandCategory brandCategoryFormディレクティブから、'changeBrandCategory'を受信した場合
         */
        $scope.$on(
          'changeBrandCategory',
          (
            event,
            categoryInfo: {
              type: string
              categoryName: string
              subCategoryName: string
            }
          ) => {
            if (categoryInfo.type !== 'post') {
              return
            }
            // 選択したメインカテゴリ、サブカテゴリをセット
            $scope.categoryName = null
            $scope.subCategoryName = null

            // メインカテゴリがある場合、スコープへカテゴリ、サブカテゴリを格納
            if (categoryInfo !== null) {
              $scope.categoryName = categoryInfo.categoryName
              $scope.subCategoryName =
                categoryInfo.subCategoryName !== '指定しない' ? categoryInfo.subCategoryName : null
            }

            $scope.getOptions.categoryFilter = $scope.categoryName
            $scope.getOptions.subCategoryFilter = $scope.subCategoryName

            initAnalyticsScope()
            // 分析のデータを取得
            if ($scope.getOptions.groupId !== null && $scope.getOptions.userId !== null) {
              getAnalyticsData()
            } else {
              // グループID、ユーザーIDが未取得の場合は、0.2秒待って、再度全分析のデータを取得する
              $timeout(() => {
                $scope.getOptions.groupId = $rootScope.groupId
                $scope.getOptions.userId = $rootScope.userId
                getAnalyticsData()
              }, 200)
            }
          }
        )

        /**
         * changeAnalyticsTab アカウント分析のタブを変更するイベント
         * @param {string} analyticsTab 分析のタブ(change、type、hashtag or characterNumber)
         */
        $scope.changeAnalyticsTab = (analyticsTab: string) => {
          $scope.analyticsTab = analyticsTab
          // 相関タブの場合は、リターン
          if (analyticsTab === 'correlation') {
            return
          }
          initAnalyticsScope()

          // 分析画面以外の場合、分析データを取得するイベントを呼び出す
          if ($state.current !== undefined && $state.current.name !== 'analytics') {
            $timeout(() => {
              getAnalyticsData()
            }, 200)
          }
        }

        /**
         * onPaginate ページングを移動するイベント
         * @param {number} page 現在のページ
         * @param {number} limit 一ページの件数
         */
        $scope.onPaginate = function (page, limit) {
          $scope.query.page = page
          $scope.query.limit = limit
          $scope.isLoading = true
          getAnalyticsData()
        }

        /**
         * onReorder ソートのイベント
         * @param {string} order ソート対象
         */
        $scope.onReorder = function (order) {
          // ページングを初期化
          $scope.query.page = 1
          $scope.query.order = order

          // ハッシュタグタブの場合
          if ($scope.analyticsTab === 'hashtag') {
            $scope.isLoading = true
            getAnalyticsData()
          } else {
            // 分析データをソート
            sortAnalyticsData()
          }
        }

        // 分析画面以外の場合、分析データを取得するイベントを呼び出す
        if ($state.current !== undefined && $state.current.name !== 'analytics') {
          $timeout(() => {
            getAnalyticsData()
          }, 200)
        }

        /**
         * ローディングフラグを変更する
         * @param {boolean} isLoading ページのローディングフラグ
         * @param {boolean} isPeriodChangeLoading グラフのローディングフラグ
         */
        $scope.changeLoadingStatus = function (isLoading: boolean, isPeriodChangeLoading: boolean) {
          $scope.isLoading = isLoading
          $scope.isPeriodChangeLoading = isPeriodChangeLoading
        }

        /**
         * アカウント詳細のデータを取得する
         */
        function getAnalyticsData() {
          // 投稿タブの場合、リターン
          if ($scope.analyticsTab === 'post') {
            return
          }

          let targetType = $scope.analyticsTab

          if (targetType === 'change') {
            targetType = $scope.selectedPeriodType
          }

          // ハッシュタグタブの場合、取得するオプションをセット
          if ($scope.analyticsTab === 'hashtag') {
            setHashtagQueryOptions()
          }

          if ($scope.analyticsTab !== 'hashtag') {
            getAnalytics(targetType)
          } else {
            getHashtags(targetType)
          }

          // フォロワー数を取得
          getAccountFollowerGraphData()
        }

        /**
         * getAnalytics 分析のデータを取得
         * @param {string} targetType ターゲット
         */
        function getAnalytics(targetType) {
          RestangularService.request('GET', '/analytics', {
            options: JSON.stringify($scope.getOptions),
            snsType: $scope.snsType,
            dailyFlg: $scope.dailyFlg,
            target: targetType,
          }).then((result) => {
            const accounts = result[0].data

            $scope.analyticsData = {
              analytics: accounts,
              accounts: null,
            }
            // 分析データをソート
            sortAnalyticsData()
          })

          if ($state && $state.current && $state.current.name === 'analytics') {
            RestangularService.request('GET', '/analytics', {
              options: JSON.stringify($scope.getOptions),
              snsType: $scope.snsType,
              dailyFlg: $scope.dailyFlg,
              target: targetType,
              type: 'countAccount',
            }).then((result) => {
              $scope.accountsCount = result[0].data.accountsCount
            })
          } else {
            $scope.accountsCount = 1
          }
        }

        /**
         * getHashtags ハッシュタグのデータを取得
         * @param {string} targetType ターゲット
         */
        function getHashtags(targetType) {
          RestangularService.request('GET', '/analytics', {
            options: JSON.stringify($scope.getOptions),
            snsType: $scope.snsType,
            target: targetType,
          }).then((result) => {
            const accounts = result[0].data

            $scope.analyticsData = {
              analytics: accounts,
              accounts: null,
            }
            // 分析データをソート
            sortAnalyticsData()
          })

          // ハッシュタグタブの場合、ハッシュタグ数と対象アカウント数をセット
          if ($scope.query.hashtagCount === null) {
            RestangularService.request('GET', '/analytics', {
              options: $scope.getOptions,
              snsType: $scope.snsType,
              target: targetType,
              type: 'countAccount',
            }).then((result) => {
              $scope.query.hashtagCount = result[0].data.hashtagsCount
              $scope.accountsCount = result[0].data.accountsCount
            })
          }
        }

        /**
         * getAccountFollowerGraphData フォロワー数を取得
         */
        function getAccountFollowerGraphData() {
          // 分析画面または推移タブ以外の場合、フォロワー数を取得しないでリターン
          if (
            ($state.current !== undefined && $state.current.name === 'analytics') ||
            $scope.analyticsTab !== 'change'
          ) {
            return
          }

          // フォロワー数のデータを取得する
          AccountDetailModalService.Data.selectFollowers(
            $scope.getOptions.startEndDate,
            $scope.getOptions.accountId,
            $scope.snsType,
            $scope.selectedPeriodType,
            $scope.dailyFlg
          ).then((accountFollowers) => {
            $scope.accountFollowers = accountFollowers
          })
        }

        /**
         * 分析データをソート
         */
        function sortAnalyticsData() {
          const order = $scope.query.order
          $scope.analyticsData.analytics = AccountAnalyticsService.Data.orderBy(
            $scope.analyticsData.analytics,
            order,
            $scope.dataPerPostFlg
          )
        }

        /**
         * フィルターの変更
         * @param {{type: string, value: any}} filterInfo
         */
        function changeFilter(filterInfo: { type: string; value: any }) {
          $scope.getOptions = AccountAnalyticsService.Data.changeFilterData(
            filterInfo.type,
            filterInfo.value,
            $scope.getOptions
          )
          initAnalyticsScope()
          // アカウント詳細のデータを取得する
          getAnalyticsData()
        }
      },
    }
  })
